export default __webpack_public_path__ + "static/media/regulatory--snow-chains--g3.a156dd58.png";